import { Component } from '@angular/core';

@Component({
    selector: 'app-piping-releases-and-revisions',
    templateUrl: './piping-releases-and-revisions.component.html',
    styleUrls: ['./piping-releases-and-revisions.component.scss'],
    standalone: false
})
export class ReleasesAndRevisionsComponent {}

